export default __webpack_public_path__ + "static/media/Arshad.045cfe8b.png";